import { useEffect, useState } from "react";
import useCategoriesStore from "../../../store/categoriesStore";
import useMenusStore from "../../../store/menusStore";
import useAdminAPI from "../../../hooks/useAdminAPI";

const Categories = () => {
    const { categories, activeCategory, setActiveCategory } =
        useCategoriesStore();

    const { activeMenu } = useMenusStore();

    useEffect(() => {
        if (activeMenu) {
            setActiveCategory(
                categories.find((c) => c.menu === activeMenu._id)?._id
            );
        }
    }, [activeMenu]);

    const { addCategoryAPI, deleteCategoryAPI, updateCategoryAPI } =
        useAdminAPI();

    const [newCategoryTitle, setNewCategoryTitle] = useState("");

    const handleAddCategory = async () => {
        if (newCategoryTitle.trim() === "") return;

        try {
            const newCategory = await addCategoryAPI({
                title: newCategoryTitle,
            });
            setNewCategoryTitle("");
        } catch (error) {
            console.error("Error adding category:", error);
        }
    };

    const handleDeleteCategory = async (categoryId) => {
        try {
            await deleteCategoryAPI(categoryId);
        } catch (error) {
            console.error("Error deleting category:", error);
        }
    };

    const handleSortOrderChange = async (e) => {
        const updatedSortOrder = parseInt(e.target.value, 10);

        const activeCategoryObj = categories.find(
            (category) => category._id === activeCategory
        );

        const updatedCategory = {
            ...activeCategoryObj,
            sortOrder: updatedSortOrder,
        };

        try {
            await updateCategoryAPI(updatedCategory);
        } catch (error) {
            console.error("Error updating sort order:", error);
        }
    };

    const getSortOrderOfCategory = (categoryId) => {
        for (let i = 0; i < categories.length; i++) {
            if (categories[i]._id === categoryId)
                return categories[i].sortOrder;
        }
        return 0;
    };

    return (
        <div className="p-4 bg-gray-100">
            <h1 className="text-2xl font-bold mb-4">Categories</h1>

            <select
                className="w-full p-2 border border-gray-300 rounded-md mb-4"
                onChange={(e) => setActiveCategory(e.target.value)}
                value={activeCategory || ""}
            >
                {categories
                    .filter((category) => category.menu === activeMenu._id)
                    .map((category) => (
                        <option key={category._id} value={category._id}>
                            {category.title}
                        </option>
                    ))}
            </select>

            {/* Sort Order Input */}
            {activeCategory && (
                <div className="mb-4">
                    <label className="block font-medium mb-2">Sort Order</label>
                    <input
                        type="number"
                        value={getSortOrderOfCategory(activeCategory) || 0}
                        onChange={handleSortOrderChange}
                        className="border rounded-md p-2 w-full"
                    />
                </div>
            )}

            {/* Add Category */}
            <div className="mb-4">
                <h2 className="text-lg font-bold mb-2">Add New Category</h2>
                <input
                    type="text"
                    placeholder="Category Title"
                    value={newCategoryTitle}
                    onChange={(e) => setNewCategoryTitle(e.target.value)}
                    className="border rounded-md p-2 w-full mb-2"
                />
                <button
                    className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-700"
                    onClick={handleAddCategory}
                >
                    Add Category
                </button>
            </div>

            {/* Delete Category */}
            {activeCategory && (
                <div>
                    <h2 className="text-lg font-bold mb-2">Delete Category</h2>
                    <button
                        className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-700"
                        onClick={() => handleDeleteCategory(activeCategory)}
                    >
                        Delete Active Category
                    </button>
                </div>
            )}
        </div>
    );
};

export default Categories;
